import styled, { css } from 'styled-components';
import { removeScrollbar } from '@/styles/helpers';

export const Wrapper = styled.div<{
  $isHomePage?: boolean;
  $isHidden?: boolean;
}>`
  position: relative;
  width: ${({ $isHomePage }) => ($isHomePage ? '1000px' : '100%')};

  ${({ $isHomePage }) =>
    $isHomePage &&
    css`
      @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        width: 100vw;
      }
    `}

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      display: none;
    `}
`;

export const Box = styled.div<{
  $isHomePage?: boolean;
}>`
  ${removeScrollbar()}

  display: flex;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.palette.primary.background};
  width: 1000px;
  padding: 20px 20px 15px;
  gap: 20px calc((100% - (105px * 8)) / 7);
  overflow-x: auto;

  ${({ $isHomePage }) =>
    $isHomePage
      ? css`
          flex-wrap: wrap;
          padding: 20px 20px 15px;
          margin: 0 auto;
          gap: 20px calc((100% - (105px * 8)) / 7);
        `
      : css`
          padding: 5px 0 15px 0;
          flex-wrap: nowrap;
          width: 100%;
          gap: 10px;
        `}

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ $isHomePage }) =>
      $isHomePage ? '20px 40px 15px' : '5px 0 15px 0'};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    gap: 5px;
    padding: ${({ $isHomePage }) =>
      $isHomePage ? '0 5px 15px' : '10px 5px 20px'};
    flex-wrap: nowrap;
    width: 100vw;
    overflow-x: auto;
  }
`;

export const ScrollButton = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 33px;
  ${({ $side }) =>
    $side === 'left'
      ? css`
          left: 0;
        `
      : css`
          right: 0;
          transform: rotate(180deg);
        `}
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 0;
  background-image: url('/images/scroll-button.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 35px;
`;
